import React from 'react'
import { Form, Input, Modal } from 'antd'

const CommentModal = ({
    isCommentModalVisible,
    handleCommentSubmit,
    handleCancel,
    comment,
    setComment
}) => {
    return (
        <Modal
            title="Provide Rejection Comment"
            open={isCommentModalVisible} // Updated prop
            onOk={handleCommentSubmit}
            onCancel={handleCancel}
            okText="Submit"
            cancelText="Cancel"
        >
            <Form>
                <Form.Item
                    label="Comment"
                    required
                >
                    <Input.TextArea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Please provide a comment for rejection"
                        rows={4}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default CommentModal